import { render, staticRenderFns } from "./GroupActions.vue?vue&type=template&id=30c7fb4f&scoped=true&"
import script from "./GroupActions.vue?vue&type=script&lang=js&"
export * from "./GroupActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c7fb4f",
  null
  
)

export default component.exports